import { render, staticRenderFns } from "./ModalLogConfig.vue?vue&type=template&id=027b267a&scoped=true&"
import script from "./ModalLogConfig.vue?vue&type=script&lang=js&"
export * from "./ModalLogConfig.vue?vue&type=script&lang=js&"
import style0 from "./ModalLogConfig.vue?vue&type=style&index=0&id=027b267a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027b267a",
  null
  
)

export default component.exports